import React from "react";
// import SideBar
import SideBar from "./SideBar";
// import Review Area
import ReviewArea from "./ReviewArea";
import { ImageConstants } from "../../assets/img/ImageConstants";

// import Img from "../../assets/img/tour/big-img.png";

const UmrahPackageDetails = () => {
  return (
    <>
      <section id="tour_details_main" className="section_padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="tour_details_leftside_wrapper">
                <div className="tour_details_heading_wrapper">
                  <div className="tour_details_top_heading">
                    <h2>UMRAH PACKAGE 2025</h2>
                    <h5>
                      <i className="fas fa-map-marker-alt"></i> Makkah, Madina
                    </h5>
                  </div>
                  <div className="tour_details_top_heading_right">
                    <h4>Excellent</h4>
                    <h6>Tentative Package</h6>
                    <p>(1214 reviews)</p>
                  </div>
                </div>
                <div className="tour_details_top_bottom">
                  <div className="toru_details_top_bottom_item">
                    <div className="tour_details_top_bottom_icon">
                      <i className="fas fa-clock"></i>
                    </div>
                    <div className="tour_details_top_bottom_text">
                      <h5>Duration</h5>
                      <p>17 days</p>
                    </div>
                  </div>
                  <div className="toru_details_top_bottom_item">
                    <div className="tour_details_top_bottom_icon">
                      <i className="fas fa-plane"></i>
                    </div>
                    <div className="tour_details_top_bottom_text">
                      <h5>Air Line</h5>
                      <p>Saudi</p>
                    </div>
                  </div>
                  <div className="toru_details_top_bottom_item">
                    <div className="tour_details_top_bottom_icon">
                      <i className="fas fa-users"></i>
                    </div>
                    <div className="tour_details_top_bottom_text">
                      <h5>Group</h5>
                      <p>50 people</p>
                    </div>
                  </div>
                  <div className="toru_details_top_bottom_item">
                    <div className="tour_details_top_bottom_icon">
                      <i className="fas fa-map-marked"></i>
                    </div>
                    <div className="tour_details_top_bottom_text">
                      <h5>Maktab</h5>
                      <p>A Zone 1</p>
                    </div>
                  </div>
                </div>
                <div className="tour_details_img_wrapper">
                  <div className="tour_react_big">
                    <img
                      className="w-100"
                      src={ImageConstants.umrahpackage}
                      alt="img"
                    />
                  </div>
                </div>
                <div className="tour_details_boxed">
                  <h3 className="heading_theme">Overview</h3>
                  <div className="tour_details_boxed_inner">
                    <p>
                      At Polani Webiye, we specialize in providing seamless
                      travel solutions, including Hajj and Umrah packages,
                      religious travel, and corporate tours. Our services are
                      designed to cater to both individual and group travelers,
                      ensuring comfort and convenience every step of the way.
                    </p>
                    <p>
                      Our Umrah packages offer an unforgettable spiritual
                      journey to Makkah and Madina. We also provide worldwide
                      travel packages for leisure and business, catering to
                      clients who seek excellence and professionalism in their
                      travel arrangements.
                    </p>
                    <ul>
                      <li>
                        <i className="fas fa-circle"></i>Spiritual guidance
                        throughout the journey
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>Expertly planned
                        itineraries for Hajj and Umrah
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>Comfortable transport
                        and accommodation
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>Assistance with visas
                        and travel documentation
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>Corporate travel
                        solutions tailored to your business needs
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="tour_details_boxed">
                  <h3 className="heading_theme">Itinerary</h3>
                  <div className="tour_details_boxed_inner">
                    <div className="accordion" id="accordionExample">
                      <div className="accordion_flex_area">
                        <div className="accordion_left_side">
                          <h5>Day 1</h5>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne">
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              Arrival in Makkah
                            </button>
                          </h2>
                          <div
                            id="collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <ul>
                                <li>
                                  <i className="fas fa-circle"></i>Arrival at
                                  King Abdulaziz International Airport
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Check-in at
                                  a 4-star hotel near Haram
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Initial
                                  Umrah rites and spiritual orientation
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="accordion_flex_area">
                        <div className="accordion_left_side">
                          <h5>Day 2</h5>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingTwo">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                            >
                              Pilgrimage Activities
                            </button>
                          </h2>
                          <div
                            id="collapseTwo"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <ul>
                                <li>
                                  <i className="fas fa-circle"></i>Visit sacred
                                  sites around Makkah
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Group prayer
                                  sessions and spiritual discussions
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="accordion_flex_area">
                        <div className="accordion_left_side">
                          <h5>Day 3</h5>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne">
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              Arrival in Makkah
                            </button>
                          </h2>
                          <div
                            id="collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <ul>
                                <li>
                                  <i className="fas fa-circle"></i>Arrival at
                                  King Abdulaziz International Airport
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Check-in at
                                  a 4-star hotel near Haram
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Initial
                                  Umrah rites and spiritual orientation
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="accordion_flex_area">
                        <div className="accordion_left_side">
                          <h5>Day 4</h5>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne">
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              Arrival in Makkah
                            </button>
                          </h2>
                          <div
                            id="collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <ul>
                                <li>
                                  <i className="fas fa-circle"></i>Arrival at
                                  King Abdulaziz International Airport
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Check-in at
                                  a 4-star hotel near Haram
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Initial
                                  Umrah rites and spiritual orientation
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Add additional days and activities as needed */}
                    </div>
                  </div>
                </div>
                <div className="tour_details_boxed">
                  <h3 className="heading_theme">Included/Excluded</h3>
                  <div className="tour_details_boxed_inner">
                    <p>
                    "Our Umrah and corporate packages are inclusive of all essentials to ensure a hassle-free experience for our clients. We provide comfortable accommodations, transportation, and guided tours to make the journey seamless and memorable. Our dedicated team takes care of every detail, from visa processing to itinerary planning, so you can focus on your spiritual journey or business needs. Whether it's a religious pilgrimage or a corporate trip, we prioritize your convenience and satisfaction every step of the way.
                    </p>
                    <ul>
                      <li>
                        <i className="fas fa-circle"></i>Return air tickets
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>Accommodation in
                        premium hotels
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>Private and group
                        transportation options
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>All necessary permits
                        and documentation
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>Dedicated travel
                        support team
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <SideBar />
            </div>
          </div>
        </div>
        {/* <ReviewArea /> */}
      </section>
    </>
  );
};

export default UmrahPackageDetails;
